import React, { ReactNode } from 'react';

import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

import Icon from 'src/components/Icon';
import Snackbar from 'src/components/Snackbar';

import { Container, LeftPart, RightPart, BgImage, Content } from './styled';

interface ExternalPageWrapperProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const ExternalPageWrapper: React.FC<ExternalPageWrapperProps> = ({ children, sx }) => {
  return (
    <Container sx={sx}>
      <LeftPart>
        <Icon iconName="logo-dark" size="97px" height="40px" viewBox="0 0 97 40" />
        <Content>{children}</Content>
      </LeftPart>
      <RightPart>
        <BgImage />
      </RightPart>
      <Snackbar />
    </Container>
  );
};

export default ExternalPageWrapper;
